/**
 * Include your custom JavaScript here.
 *
 * We also offer some hooks so you can plug your own logic. For instance, if you want to be notified when the variant
 * changes on product page, you can attach a listener to the document:
 *
 * document.addEventListener('variant:changed', function(event) {
 *   var variant = event.detail.variant; // Gives you access to the whole variant details
 * });
 *
 * You can also add a listener whenever a product is added to the cart:
 *
 * document.addEventListener('product:added', function(event) {
 *   var variant = event.detail.variant; // Get the variant that was added
 *   var quantity = event.detail.quantity; // Get the quantity that was added
 * });
 *
 * If you are an app developer and requires the theme to re-render the mini-cart, you can trigger your own event. If
 * you are adding a product, you need to trigger the "product:added" event, and make sure that you pass the quantity
 * that was added so the theme can properly update the quantity:
 *
 * document.documentElement.dispatchEvent(new CustomEvent('product:added', {
 *   bubbles: true,
 *   detail: {
 *     quantity: 1
 *   }
 * }));
 *
 * If you just want to force refresh the mini-cart without adding a specific product, you can trigger the event
 * "cart:refresh" in a similar way (in that case, passing the quantity is not necessary):
 *
 * document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {
 *   bubbles: true
 * }));
 */

/* ==========================================================================
   Movie Prop Purchase Policy
   The Cargo Hold Designs
   ========================================================================== */

(function () {

  function initMoviePropPolicy() {

    const checkbox = document.getElementById('prop-policy-check');

    if (!checkbox) return;

    const addToCartButton = document.querySelector('.product-form__add-button');
    const buyNowContainer = document.querySelector('.shopify-payment-button');

    if (!addToCartButton) return;

    // Create status message (only once)
    let statusMessage = document.getElementById('policy-status-message');

    if (!statusMessage) {
      statusMessage = document.createElement('div');
      statusMessage.id = 'policy-status-message';
      statusMessage.style.marginTop = '12px';
      statusMessage.style.fontWeight = '600';
      statusMessage.style.fontSize = '14px';
      checkbox.closest('label').after(statusMessage);
    }

    function updateButtons() {

      if (checkbox.checked) {

        // Enable Add to Cart
        addToCartButton.disabled = false;
        addToCartButton.style.opacity = "";
        addToCartButton.style.cursor = "";
        addToCartButton.style.pointerEvents = "";

        // Enable Buy It Now
        if (buyNowContainer) {
          buyNowContainer.style.pointerEvents = "";
          buyNowContainer.style.opacity = "";
        }

        statusMessage.style.color = "#2d8f2d";
        statusMessage.innerHTML = "&#10004; Thank you! You may now add this item to your cart.";

      } else {

        // Disable Add to Cart
        addToCartButton.disabled = true;
        addToCartButton.style.opacity = "0.55";
        addToCartButton.style.cursor = "not-allowed";
        addToCartButton.style.pointerEvents = "none";

        // Disable Buy It Now
        if (buyNowContainer) {
          buyNowContainer.style.pointerEvents = "none";
          buyNowContainer.style.opacity = "0.55";
        }

        statusMessage.style.color = "#d9534f";
        statusMessage.innerHTML = "&#9888; Please acknowledge the purchase information above to continue.";

      }

    }

    updateButtons();

    checkbox.removeEventListener('change', updateButtons);
    checkbox.addEventListener('change', updateButtons);

  }

  document.addEventListener('DOMContentLoaded', initMoviePropPolicy);

  document.addEventListener('variant:changed', function () {
    setTimeout(initMoviePropPolicy, 100);
  });

  document.addEventListener('shopify:section:load', function () {
    setTimeout(initMoviePropPolicy, 100);
  });

})();